"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiVersion = void 0;
const VersionNumber_1 = require("./VersionNumber");
/**
 * This is the singleton wrapper of VersionNumber
 */
class ApiVersion {
    /**
     * Gets the singleton instance of the version number.
     */
    static get Instance() {
        return ApiVersion._instance;
    }
    static SetVersionNumber(numString, isAlpha) {
        ApiVersion._instance = new VersionNumber_1.VersionNumber(numString, isAlpha);
    }
}
exports.ApiVersion = ApiVersion;
//# sourceMappingURL=ApiVersion.js.map